export default "__VITE_PUBLIC_ASSET__e23854a8__"